module.exports = __webpack_public_path__ + "static/media/movie1.09e75be4.jpeg";